// Download a change-log entry's Markdown document as a .md file.
// Filename is derived from the title, stripping characters invalid on Windows (incl. the ":" in timestamps).
export function downloadChangeMarkdown(title?: string | null, document?: string | null) {
  const name = (title || "agent-change").replace(/[<>:"/\\|?*\x00-\x1f]/g, "-").replace(/\s+/g, " ").trim()
  const blob = new Blob([document || ""], { type: "text/markdown;charset=utf-8" })
  const url = URL.createObjectURL(blob)
  const a = window.document.createElement("a")
  a.href = url
  a.download = `${name}.md`
  a.click()
  URL.revokeObjectURL(url)
}
